export class Text {
    textEn: string;
    textFr: string;

    constructor(textEn?, textFr? ) {
        this.textEn = textEn;
        this.textFr = textFr;
    }
}